import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import RawText from './RawText';
import PropTypes from 'prop-types';
import { st, classes } from './Text.st.css';
import Ellipsis, { extractEllipsisProps } from '../common/Ellipsis';

var TextWithEllipsis = function TextWithEllipsis(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var _extractEllipsisProps = extractEllipsisProps(props),
      ellipsisProps = _extractEllipsisProps.ellipsisProps,
      componentProps = _extractEllipsisProps.componentProps;

  return /*#__PURE__*/React.createElement(Ellipsis, _extends({}, ellipsisProps, {
    wrapperClassName: st(classes.root, {
      size: props.size,
      weight: props.weight
    }),
    render: function render(_ref2) {
      var ref = _ref2.ref,
          ellipsisClasses = _ref2.ellipsisClasses,
          ellipsisInlineStyle = _ref2.ellipsisInlineStyle;
      return /*#__PURE__*/React.createElement(RawText, _extends({}, componentProps, {
        ref: ref,
        className: ellipsisClasses(className),
        style: ellipsisInlineStyle
      }));
    }
  }));
};

TextWithEllipsis.displayName = 'Text';
TextWithEllipsis.propTypes = {
  /*
   * Text props
   */

  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** class to be applied to the root element */
  className: PropTypes.string,

  /** tag name that will be rendered */
  tagName: PropTypes.string,

  /** font size of the text */
  size: PropTypes.oneOf(['tiny', 'small', 'medium']),

  /** any nodes to be rendered (usually text nodes) */
  children: PropTypes.any,

  /** is the text type is secondary. Affects the font color */
  secondary: PropTypes.bool,

  /** skin color of the text */
  skin: PropTypes.oneOf(['standard', 'success', 'error', 'premium', 'disabled', 'primary']),

  /** make the text color lighter */
  light: PropTypes.bool,

  /** font weight of the text */
  weight: PropTypes.oneOf(['thin', 'normal', 'bold']),

  /*
   * Ellipsis props
   */

  /** When true, text that is longer than it's container will be truncated to a single line followed by ellipsis. Otherwise the text will break into several lines. */
  ellipsis: PropTypes.bool,

  /** True by default, set it to false in order to show ellipsis without a tooltip. */
  showTooltip: PropTypes.bool,

  /** tooltips content zindex */
  zIndex: PropTypes.number,

  /** tooltip content placement in relation to target element */
  placement: PropTypes.string,

  /** disables tooltip element trigger behaviour. If not specified, `disabled` prop of the `children` element will be used. */
  disabled: PropTypes.bool,

  /** tooltips content calculation relation to a dom element. Can be either:
   *  `'window', 'scrollParent', 'viewport', 'parent'`, `element` or
   * `function` based predicate i.e. (elm) =>
   *  elm.getAttribute('data-hook') === 'value'
   */
  appendTo: PropTypes.oneOfType([PropTypes.oneOf(['window', 'scrollParent', 'viewport', 'parent']), PropTypes.element, PropTypes.func]),

  /** whether to enable the flip behaviour. This behaviour is used to flip the Tooltips placement when it starts to overlap the target element. */
  flip: PropTypes.bool,

  /** whether to enable the fixed behaviour. This behaviour is used to keep the Tooltip at it's original placement even when it's being positioned outside the boundary. */
  fixed: PropTypes.bool,

  /** time in milliseconds to wait before showing the tooltip */
  enterDelay: PropTypes.number,

  /**  time in milliseconds to wait before hiding the tooltip. Defaults to 0. */
  exitDelay: PropTypes.number,

  /** tooltip content container width in pixels */
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** callback on tooltips content show event */
  onShow: PropTypes.func,

  /** callback on tooltips content hide event */
  onHide: PropTypes.func,

  /** moves tooltip content relative to the parent by x or y */
  moveBy: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),

  /** Moves arrow by amount */
  moveArrowTo: PropTypes.number,

  /** align tooltip content */
  textAlign: PropTypes.oneOf(['start', 'center'])
};
TextWithEllipsis.defaultProps = _objectSpread(_objectSpread({}, RawText.defaultProps), Ellipsis.defaultProps);
export default TextWithEllipsis;